import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39da178a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brandtabs-container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandtabs, (tab, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: tab.id,
        class: _normalizeClass(_ctx.isActiveTab(tab) ? 'active' : ''),
        onClick: ($event: any) => (_ctx.handleTabChange(index, true))
      }, _toDisplayString(tab.name), 11, _hoisted_2))
    }), 128))
  ]))
}